import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import clsx from 'clsx';
import { useCallback, useState } from 'react';
import Video from '../../Video/Video';
import useStyles from './VideoContainer.styles';
const VideoContainer = (props) => {
    const { classes } = useStyles();
    const [isPortrait, setIsPortrait] = useState(false);
    const handlePortraitDetected = useCallback((portrait) => setIsPortrait(portrait), []);
    return (_jsx(Box, { className: clsx(classes.videoContainer, classes.squareVideoContainer, isPortrait && classes.portraitVideoContainer), children: _jsx(Video, Object.assign({ video: Object.assign({}, props.video) }, props, { isFromContentFeature: true, onPortraitDetected: handlePortraitDetected })) }));
};
export default VideoContainer;
